import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import BakeasyLoader, { BakeasyLoaderProp } from './components/loaders/BakeasyLoader';
import BakeasySnackbar, { BakeasySnackbarProp } from './components/snackbars/BakeasySnackBar';
import BakeasyConfirmDialog, {
  BakeasyConfirmDialogProp
} from './components/dialogs/BakeasyConfirmDialog';
import { AppContext } from './context/AppContext';
import AppRoutes from './routes/AppRoutes';
import BakeasyDialog, { BakeasyDialogProp } from './components/dialogs/BakeasyDialog';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Provider } from 'react-redux';
import { store } from './redux_store/reduxStore';
import BakeasyLoaderRedux from './components/loaders/BakeasyLoaderRedux';
import BakeasySnackbarRedux from './components/snackbars/BakeasySnackBarRedux';

const App = () => {
  const [loader, setLoader] = useState<BakeasyLoaderProp>({});
  const [dialog, setDialog] = useState<BakeasyDialogProp>({});
  const [snackbar, setSnackbar] = useState<BakeasySnackbarProp>({});
  const [confirmDialog, setConfirmDialog] = useState<BakeasyConfirmDialogProp>({});
  const [isMobileView, setIsMobileView] = useState<boolean>(true);

  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppContext.Provider
          value={{
            loader,
            setLoader,
            dialog,
            setDialog,
            snackbar,
            setSnackbar,
            confirmDialog,
            setConfirmDialog,
            isMobileView,
            setIsMobileView
          }}
        >
          <BrowserRouter>
            <AppRoutes />
            <BakeasyLoader loader={loader} />
            <BakeasyDialog dialog={dialog} />
            <BakeasyLoaderRedux />
            <BakeasySnackbarRedux />
            <BakeasySnackbar snackbar={snackbar} />
            <BakeasyConfirmDialog dialog={confirmDialog} />
          </BrowserRouter>
        </AppContext.Provider>
      </LocalizationProvider>
    </Provider>
  );
};

export default App;
